/**
 * Validates a `returnTo` before any redirect consumes it: an unchecked `//evil.com` or an absolute
 * URL would send an authenticated admin off-site right after login — an open redirect, not a
 * cosmetic issue. Accepts only same-origin absolute paths: must start with a single `/`, never `//`
 * or `/\`, both of which browsers treat as protocol-relative.
 */
export function safeReturnTo(value: string | null | undefined, fallback = '/'): string {
  if (!value) return fallback;

  let candidate: string;
  try {
    candidate = decodeURIComponent(value);
  } catch {
    // Malformed percent-encoding — treat as hostile input.
    return fallback;
  }

  if (!candidate.startsWith('/')) return fallback;
  if (candidate.startsWith('//') || candidate.startsWith('/\\')) return fallback;
  // Reject anything that parses as an absolute URL with its own origin.
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(candidate)) return fallback;

  return candidate;
}
